import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useTranslationHook from '../../../../hooks/useTranslationHook';
import FileUploadItem from '../../../../seller/property/FileUploadItem';
import { updateBuyerRegistrationField } from '../../../../../redux/slice/buyerSlice';
import { BUYER_REGISTRATION_STEPS, RegistrationFlowType, Set_Bid_Registration_Doc } from './constant';
import { handleAuctionBidRegistration } from '../../../../../redux/action/buyerAction';
import { toast } from 'react-toastify';

const DocumentsUpload = () => {
    const dispatch = useDispatch();
    const { t } = useTranslationHook();

    const { principalIdDoc, powerOfAttorneyDoc, completed } = useSelector(
        (state) => state.buyer.buyerRegistration.principal.stepTwoData
    );

    const registration_id = useSelector(
        (state) => state.buyer.buyerRegistration.registration_id
    );

    const isFormValid = useMemo(
        () => Boolean(principalIdDoc && powerOfAttorneyDoc),
        [principalIdDoc, powerOfAttorneyDoc]
    );

    const setBuyerField = useCallback(
        (field, value) => {
            dispatch(updateBuyerRegistrationField({ field, value }));
        },
        []
    );

    const goToNextStep = () => {
        setBuyerField('step', BUYER_REGISTRATION_STEPS.REVIEW)
    };


    const submitUploadDocument = async () => {
        if (completed) {
            goToNextStep();
            return;
        }
        const response = await dispatch(handleAuctionBidRegistration({
            step: 2,
            bid_registration: registration_id,
            principal_id_document: principalIdDoc?.upload_id ?? null,
            power_of_attorney_document: powerOfAttorneyDoc?.upload_id ?? null,
        }));

        const { code, error, msg } = response || {};

        if (code !== 1 || error !== 0) {
            toast.info(msg || "Something went wrong");
            console.info("Upload Document Error:", response);
            return;
        }

        toast.success(msg);
        dispatch(
            updateBuyerRegistrationField({
                section: RegistrationFlowType.PRINCIPAL,
                stepKey: "stepTwoData",
                value: { completed: true },
            })
        );
        goToNextStep();
    }

    return (
        <div className="step-2">
            <section className="bidder-progress">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <h5>
                                <span>
                                    2/3
                                </span>
                                {t("UploadRequiredDocuments")}
                            </h5>
                            <ul>
                                <li className="step active"></li>
                                <li className="step"></li>
                                <li></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bidder-form">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <div className="mb-3">
                                <h6>{t("Documents")}</h6>
                                <ul className="doc-list">
                                    <FileUploadItem
                                        iconSrc="/img/documents-icon.svg"
                                        title={t("PrincipalsIdDocument")}
                                        required={true}
                                        subtitle={
                                            !principalIdDoc &&
                                            t("1 Image Required")
                                        }
                                        bucketName="bidder_document"
                                        section="documents"
                                        property="principalIdDoc"
                                        documents={principalIdDoc}
                                        docType="16"
                                        // imageOnly={true}
                                        allowMultiple={false}
                                        module={Set_Bid_Registration_Doc}
                                    />
                                    <FileUploadItem
                                        iconSrc="/img/documents-icon.svg"
                                        title={t("PowerOfAttorneyDocument")}
                                        required={true}
                                        subtitle={
                                            !powerOfAttorneyDoc &&
                                            t("1 Image Required")
                                        }
                                        bucketName="bidder_document"
                                        section="documents"
                                        property="powerOfAttorneyDoc"
                                        documents={powerOfAttorneyDoc}
                                        docType="16"
                                        // imageOnly={true}
                                        allowMultiple={false}
                                        module={Set_Bid_Registration_Doc}
                                    />
                                </ul>
                            </div>

                            <div className="bidder-btns mb-4">
                                <button
                                    onClick={() => {
                                        setBuyerField('step', BUYER_REGISTRATION_STEPS.DETAILS);
                                    }}
                                    className="btn btn-sky back-btn"
                                >
                                    <img src="/img/arrow-left.svg" className="mr4" alt="" />
                                    {t("Back")}
                                </button>
                                <button
                                    onClick={submitUploadDocument}
                                    className="btn btn-primary forward-btn"
                                    disabled={!isFormValid}
                                >
                                    {t("Next")}
                                    <img src="/img/arrow-right.svg" className="ml4" alt="" />
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default DocumentsUpload 
